import React, { useEffect, useState } from "react";

interface YouTubeBackgroundProps {
  videoIds: string[];
  className?: string;
}

const YouTubeBackground: React.FC<YouTubeBackgroundProps> = ({ videoIds, className = "" }) => {
  const [selectedVideoId, setSelectedVideoId] = useState<string>("");

  useEffect(() => {
    // Randomly select a video ID when the component mounts
    const randomIndex = Math.floor(Math.random() * videoIds.length);
    setSelectedVideoId(videoIds[randomIndex]);
  }, [videoIds]);

  if (!selectedVideoId) return null;

  return (
    <div className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`}>
      <div className="absolute inset-0 bg-gray-900/40 z-5"></div>
      <div className="absolute inset-0 w-full h-full">
        <div
          style={{
            position: "relative",
            paddingBottom: "56.25%" /* 16:9 aspect ratio */,
            overflow: "hidden",
            width: "100%",
            height: "100%",
          }}
        >
          <iframe
            src={`https://www.youtube.com/embed/${selectedVideoId}?autoplay=1&mute=1&controls=0&showinfo=0&rel=0&loop=1&playlist=${selectedVideoId}&playsinline=1&enablejsapi=1`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Background Video"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "150%" /* Larger than container to ensure full coverage */,
              height: "150%" /* Larger than container to ensure full coverage */,
              border: "none",
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default YouTubeBackground;
